import {getGlobalProperties} from "@/src/shared/helpers/getGlobalProperties";
import {ref} from "vue";

export default function useNotes() {
  const {$api, $toast} = getGlobalProperties()

  const noteFormLoading = ref(false)

  if (!$api) {
    console.error("API instance is not available");
  }

  //add note
  const addNote = (noteBody: string, opponentId: number) => {
    noteFormLoading.value = true
    const params = {
      about: opponentId,
      body: noteBody,
    }
    return $api.post('/api/user/notes', params)
      .then((res: any) => {
        noteFormLoading.value = false
        return res.data
      })
      .catch((error: any) => {
        console.error(error.response);
        noteFormLoading.value = false
        if (error.response)
          $toast({
            message: error.response,
            type: 'error'
          });
      })
  }

  const editNote = (noteBody: string, noteId: string) => {
    noteFormLoading.value = true
    const params = {
      body: noteBody,
    }
    return $api.put(`/api/user/notes/${noteId}`, params)
      .then(() => {
        noteFormLoading.value = false
      })
      .catch((error: any) => {
        console.error(error.response);
        noteFormLoading.value = false
        if (error.response)
          $toast({
            message: error.response,
            type: 'error'
          });
      })
  }

  const deleteNote = (noteId: string) => {
    noteFormLoading.value = true
    return $api.delete(`/api/user/notes/${noteId}`)
      .then(() => {
        noteFormLoading.value = false
      })
      .catch((error: any) => {
        console.error(error.response);
        noteFormLoading.value = false
        if (error.response)
          $toast({
            message: error.response,
            type: 'error'
          });
      })
  }

  return {
    addNote, editNote, deleteNote, noteFormLoading
  };
}
